var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"InputData"}},[_c('input',{ref:"dataTarefa",attrs:{"id":"data","type":"text"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateDate($event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5453c52b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lead/form/InputData.vue
// module id = null
// module chunks = 